import React, { useEffect, useState } from "react";

const CookieConsent = ({ lang = "tr" }) => {
  const [visible, setVisible] = useState(false);
  const t = translations[lang] || translations["tr"];

  useEffect(() => {
    const stored = localStorage.getItem("cookieAccepted");
    if (!stored) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieAccepted", "true");
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem("cookieAccepted", "false");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="animated fadeInUp" style={styles.container}>
      <div style={styles.text}>
        {t.message}
        <span
          onClick={() =>
            (window.location.href = "/sikca-sorulanlar-ve-bilgiler")
          }
          style={styles.link}
        >
          {" "}
          {t.more}
        </span>
      </div>
      <div style={styles.actions}>
        <button onClick={handleReject} style={styles.reject}>
          {t.reject}
        </button>
        <button onClick={handleAccept} style={styles.accept}>
          {t.accept}
        </button>
      </div>
    </div>
  );
};

const translations = {
  tr: {
    message:
      "İçeriği, reklamları kişiselleştirmek ve site yönetimini analiz etmek için üçüncü taraf çerezlerini yürütmek.",
    more: "Daha Fazlası →",
    reject: "Çerezleri Reddet",
    accept: "Çerezleri Kabul Et",
  },
  en: {
    message:
      "We use third-party cookies to personalize content, ads, and analyze site traffic.",
    more: "Learn More →",
    reject: "Reject Cookies",
    accept: "Accept Cookies",
  },
};

const styles = {
  container: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "#2c6fb7",
    color: "white",
    padding: "16px 24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
    zIndex: 9999,
  },
  text: {
    flex: 1,
    fontSize: "14px",
    marginRight: "20px",
  },
  link: {
    color: "#ffffff",
    textDecoration: "underline",
    cursor: "pointer",
    marginLeft: "6px",
    fontWeight: "bold",
  },
  actions: {
    display: "flex",
    gap: "10px",
  },
  reject: {
    backgroundColor: "transparent",
    color: "white",
    border: "none",
    fontSize: "14px",
    cursor: "pointer",
  },
  accept: {
    backgroundColor: "white",
    color: "#2c6fb7",
    padding: "6px 12px",
    border: "none",
    borderRadius: "4px",
    fontWeight: "bold",
    cursor: "pointer",
  },
};

export default CookieConsent;
